/**
 * FinishFilterDropdown - Card finish filter built on the generic FilterDropdown.
 *
 * Renders finish types (Non-Foil, Foil, Etched) as a searchable multi-select dropdown.
 * Uses mana-font foil icon for visual clarity.
 */
import type { ReactElement } from 'react';

import type { FilterDropdownOption } from '@/components/FilterDropdown/FilterDropdown';
import FilterDropdown from '@/components/FilterDropdown/FilterDropdown';
import type { Finish } from '@/types/card';

export interface FinishFilterDropdownProps {
  selectedFinishes: Finish[];
  onToggle: (finish: Finish) => void;
  onClear: () => void;
  className?: string;
}

const FINISH_OPTIONS: FilterDropdownOption[] = [
  { value: 'nonfoil', label: 'Non-Foil', badgeClassName: 'bg-zinc-500/20 text-zinc-400' },
  { value: 'foil', label: 'Foil', badgeClassName: 'bg-amber-500/20 text-amber-400' },
  { value: 'etched', label: 'Etched', badgeClassName: 'bg-indigo-500/20 text-indigo-400' },
];

export default function FinishFilterDropdown({ selectedFinishes, onToggle, onClear, className }: FinishFilterDropdownProps): ReactElement {
  return (
    <FilterDropdown
      triggerLabel="Finish"
      ariaLabel="Finish filter"
      searchPlaceholder="Search finishes..."
      options={FINISH_OPTIONS}
      selectedValues={selectedFinishes}
      onToggle={(value) => onToggle(value as Finish)}
      onClear={onClear}
      className={className}
    />
  );
}
